import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CommentTypeLabel, WorkingMode } from '../../types';
import { determineTimeStringByTimezone, formatNumberString, global, } from '../../utils';
import format from 'date-fns/format';
import styles from './ActuatorCircuitActivityChartToolTip.module.css';
import parseISO from 'date-fns/parseISO';
const ActuatorCircuitActivityChartToolTip = ({ locale, payload, label, ianaTimeZoneCode, }) => {
    var _a, _b;
    const payloadExists = !!((_a = payload === null || payload === void 0 ? void 0 : payload[0]) === null || _a === void 0 ? void 0 : _a.payload);
    if (!payloadExists)
        return null;
    const truePayload = payload[0].payload;
    const circuitActivity = truePayload === null || truePayload === void 0 ? void 0 : truePayload.circuitActivityValue;
    const overriddenCircuitActivity = truePayload === null || truePayload === void 0 ? void 0 : truePayload.overriddenCircuitActivityValue;
    const forcedOff = truePayload === null || truePayload === void 0 ? void 0 : truePayload.overrideForcedOffValue;
    const forcedOn = truePayload === null || truePayload === void 0 ? void 0 : truePayload.overrideForcedOnValue;
    const workingMode = truePayload === null || truePayload === void 0 ? void 0 : truePayload.workingMode;
    const isLocalOverride = truePayload === null || truePayload === void 0 ? void 0 : truePayload.isLocalOverrideActive;
    const noCircuitActivity = circuitActivity === null || circuitActivity === undefined;
    const noOverrideCircuitActivity = overriddenCircuitActivity === null ||
        overriddenCircuitActivity === undefined;
    const renderCommentTooltips = ({ payload }) => {
        const { from, commentValue, commentType, comment, userName, createdAt } = payload;
        const renderCommnetCircuitActivity = () => {
            if (commentValue === 1) {
                return 'Circuit On';
            }
            else {
                return 'Circuit Off';
            }
        };
        const valueTimeString = determineTimeStringByTimezone(parseISO(from), locale.fullDateTimeFormat, ianaTimeZoneCode, true);
        const createdAtTimeString = determineTimeStringByTimezone(parseISO(createdAt), locale.fullDateTimeFormat, ianaTimeZoneCode, true);
        return (_jsx("div", Object.assign({ className: styles.root }, { children: _jsxs("div", Object.assign({ className: styles.commentWrapper }, { children: [_jsx("div", Object.assign({ className: styles.secondaryText }, { children: valueTimeString }), void 0), _jsx("div", Object.assign({ className: styles.commentValue }, { children: _jsx("strong", { children: renderCommnetCircuitActivity() }, void 0) }), void 0), _jsxs("div", Object.assign({ className: styles.commentTextContainer }, { children: [_jsx("div", Object.assign({ className: styles.commentType }, { children: _jsx("strong", { children: CommentTypeLabel[commentType] }, void 0) }), void 0), _jsx("div", Object.assign({ className: styles.commentText }, { children: comment }), void 0), _jsxs("div", Object.assign({ className: styles.secondaryText }, { children: [userName, " commented on ", createdAtTimeString] }), void 0)] }), void 0)] }), void 0) }), void 0));
    };
    const renderCircuitActivity = () => {
        if (noCircuitActivity && noOverrideCircuitActivity)
            return global.NOT_AVAILABLE;
        if (circuitActivity === 1 || overriddenCircuitActivity === 1 || forcedOn) {
            return 'Circuit On';
        }
        else if (circuitActivity === 0 ||
            overriddenCircuitActivity === 0 ||
            forcedOff) {
            return 'Circuit Off';
        }
        return global.NOT_AVAILABLE;
    };
    const renderOverrideActivity = () => {
        let overrideText = '';
        if (workingMode === WorkingMode.CALIBRATION) {
            overrideText = 'Manual Mode';
        }
        if (forcedOff === 0.15) {
            overrideText = 'Forced Off';
        }
        if (forcedOn === 0.15) {
            overrideText = 'Forced On';
        }
        if (overrideText === '')
            return null;
        return (_jsxs("div", Object.assign({ className: styles.override }, { children: [_jsx("div", { children: overrideText }, void 0), isLocalOverride && (_jsx("div", Object.assign({ className: styles.localOverride }, { children: "Local Override" }), void 0))] }), void 0));
    };
    const commentPayload = payload.find((p) => p.dataKey === 'commentValue');
    if (commentPayload && ((_b = commentPayload.payload) === null || _b === void 0 ? void 0 : _b.timestamp) === label) {
        return renderCommentTooltips({
            payload: commentPayload.payload,
        });
    }
    else {
        return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx("div", Object.assign({ className: styles.date }, { children: determineTimeStringByTimezone(new Date(label), locale.fullDateTimeFormat, ianaTimeZoneCode, true) }), void 0), _jsx("div", Object.assign({ className: styles.tooltipMainText }, { children: renderCircuitActivity() }), void 0), renderOverrideActivity()] }), void 0));
    }
};
export const LightReadingTooltip = ({ locale, payload, label }) => {
    var _a;
    const payloadExists = !!((_a = payload === null || payload === void 0 ? void 0 : payload[0]) === null || _a === void 0 ? void 0 : _a.payload);
    if (!payloadExists)
        return null;
    const truePayload = payload[0].payload;
    const lightReadingValue = truePayload === null || truePayload === void 0 ? void 0 : truePayload.lux;
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx("div", Object.assign({ className: styles.date }, { children: format(new Date(label), locale.fullDateTimeFormat) }), void 0), _jsx("div", Object.assign({ className: styles.tooltipMainText }, { children: formatNumberString(lightReadingValue, {
                    unit: 'lux',
                    numDecimals: 1,
                    spaceBetweenValueAndUnit: true,
                    useNotAvailableText: true,
                }) }), void 0)] }), void 0));
};
export default ActuatorCircuitActivityChartToolTip;
